import { useEffect, useState } from 'react';
import './styles/app.css';
import { LoggedInLayout } from './components/ui/main/Layout';
import { useUser } from './biz/hooks/entities/useUser';
import { RouteMapping } from './components/ui/main/RouteMapping';
import { LoadingScreeen } from './components/ui/main/LoadingScreeen';
import { LoginScreen } from './components/ui/Simple/Login';
import { GenericDialog, GenericToast } from './components/ui/Simple/MesssageBoxes';
import "./translations/translations";
import { useTranslation } from 'react-i18next';

const App = () => {
  const user = useUser();
  const [loadingUser, setLoadingUser] = useState<boolean>(false);
  const { t } = useTranslation();

  let userLoaded = false;


  const onStart = async () => {
    if (userLoaded) { return };
    userLoaded = true;

    setLoadingUser(true);
    const e = await user.loadUser();
    setLoadingUser(false);
  }

  useEffect(() => {
    onStart();
  }, []);

  return (<>

    {(loadingUser) && (
      <LoadingScreeen text={t("loading")} />
    )}

    <LoggedInLayout loggedin={user.loggedIn && loadingUser == false}>
      <RouteMapping />
    </LoggedInLayout>

    {(!user.loggedIn && loadingUser == false) && (
      <LoginScreen />
    )}

    <GenericDialog />
    <GenericToast />

    {/* {(loadingUser) && (
      <LoadingScreeen />
    )} */}

  </>

  );
}

export default App;
